export const dummyCarts = {
  cartId: '2l1sqm54jic1a91u2msukjf5llhi5jvq',
  items: [
    {
      id: '7f8543c6-b65e-40fd-bbf8-f057d2444871',
      product_name: 'Demon Slayer Executive Logo Shirt - Off White',
      sell_price: 179900,
      product_assets: [
        {
          assets_type: 'image',
          assets_url:
            'https://dev-storage.jubelio.com/demo-c/images/jstorev2/627d2b73-268a-437f-adda-693f6d6b0c8e.jpeg',
        },
      ],
      quantity: 1,
      variants: [
        {
          option_id: '7f8543c6-b65e-40fd-bbf8-f057d2444871',
          variant_id: '7f8543c6-b65e-40fd-bbf8-f057d2444871',
          label: 'Off White',
        },
        {
          option_id: '4d844d90-1e8a-4a13-9194-32900db99723',
          variant_id: '4d844d90-1e8a-4a13-9194-32900db99723',
          label: 'M',
        },
      ],
      sku: 'Exe-Demon-Off_White-M',
      discount_price: 10000,
    },
  ],
  subtotal: 179900,
  grand_total: 242000,
  shipping_cost: 9000,
  tax_amount: 23981.99,
  is_tax_included: true,
};
